export type ShippingMethodSliceInitialState = {
  pending?: ShippingMethod[];
};

type ShippingMethodAddressConditions = {
  is_us_post_office_box: boolean;
  is_armed_forces: boolean;
  is_international: boolean;
  is_us_territory: boolean;
  is_alaska_or_hawaii: boolean;
  eligible_for_freight: boolean;
};

export type ShippingMethodAPIResponse = {
  shipping_methods: ShippingMethod[];
  cart_contents_require_freight: boolean;
  total_shipping_method_count: number;
  address: ShippingMethodAddressConditions;
};

export type ShippingMethodType = 'drop_ship' | 'pickup' | 'standard';

export type ShippingMethod = {
  api_id: number;
  name: string;
  price: number;
  charged_at_cost: boolean;
  type: ShippingMethodType;
  details_html: string | null;
};

export type PickupShippingMethod = Pick<ShippingMethod, 'api_id' | 'details_html' | 'name'>;
